module.exports = __webpack_public_path__ + "img/logo.8fb026a5.png";